import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPage.css';

const RefundPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-container">
          {/* Header Section */}
          <div className="legal-header">
            <Link to="/" className="back-button">
              <ArrowLeft size={20} />
              <span>Back to Home</span>
            </Link>
            
            <div className="legal-title-section">
              <h1 className="legal-main-title">Refund & Cancellation Policy</h1>
              <p className="legal-subtitle">
                Important information about our refund and cancellation policies.
              </p>
              <div className="legal-last-updated">
                Last updated: July 2025
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="legal-content">
            <div className="legal-content-card">
              
              <div className="legal-section">
                <h2>Refund & Cancellation Policy</h2>
                <ul>
                  <li>All payments made on <strong>echoesoflunaria.com</strong>, including donations and vos purchases, are final and non-refundable.</li>
                  <li>We do not accept refund requests or cancellations for any reason once a transaction is completed.</li>
                  <li>Please ensure you review your choices carefully before confirming any payment.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Contact</h2>
                <p>For questions, contact:</p>
                <p className="contact-info">📧 echosoflunaria@gmail.com</p>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundPolicy;